import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

export const Body = styled.div`
  padding: ${space['space-400']} 0 ${space['space-600']};
`;

export const Grid = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${space['space-300']};
`;

export const Card = styled.li`
  margin: 0;
  padding: 0;
`;

export const CardButton = styled.button<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['space-100']};
  width: 100%;
  padding: ${space['space-500']};
  background: ${semantic.bg.canvas};
  border: ${({ $active }) =>
      $active ? size.stroke['stroke-thick'] : size.stroke['stroke-default']}
    solid ${({ $active }) => ($active ? semantic.border.selected : semantic.border.default)};
  border-radius: ${radius('card', 'radius-lg')};
  box-sizing: border-box;
  cursor: pointer;
  text-align: left;
  font-family: ${fonts.body};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const Name = styled.span`
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const Region = styled.span`
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.secondary};
`;
